import { Navigate, Outlet } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

const PrivateRoute = ({ allowedRoles }) => {
  const { user } = useContext(AuthContext);
  const userGroups = user?.groups || [];

  return (
    userGroups.some(group => allowedRoles?.includes(group))
      ? <Outlet />
      : <Navigate to="/user-login" replace />
  );
};

export default PrivateRoute;
